import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toast } from "react-toastify";
import { onChange_Createuser_Cohorts } from "../../../CreateUserComp/action";
import { useNavigate, useParams } from "react-router-dom";
import CohortUpdateDetailsComponent from "./component";

const CohortUpdateDetailsContainer = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [cohortTypes, setCohortTypes] = useState([]);
  const [selectedCohortType, setSelectedCohortType] = useState("");
  const [selectedVM, setSelectedVM] = useState([]);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    cohortType: "",
    description: "",
    areaName: "",
    lat: "",
    lng: "",
    cohortTypeId:""
  });

  useEffect(() => {
    handleGetSeedData();
    LoadCohortViewDetails();
  }, []);


  const LoadCohortViewDetails = () => {
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${id}`,
      "GET",
      undefined,
      (response) => {
        if (response) {
          setFormData({
            name: response.name || "",
            cohortType: response.cohortTypeName || "",
             cohortTypeId: response.cohortTypeId || "",
            description: response.description || "",
            areaName: response.areaName || "",
            lat: parseFloat(response.lat) || 5,   
          lng: parseFloat(response.lng) || 5,  
          });

          setSelectedCohortType(response.cohortType || "");

          setSelectedVM(response.machines || []);
        }
        setLoading(false);
      },
      (err) => {
        toastr.error("Failed", "Unable to fetch cohort details");
        setLoading(false);
      }
    );
  };


  const handleGetSeedData = () => {
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/seed`,
      "GET",
      undefined,
      (response) => {
        setCohortTypes(response?.cohort_types || []);
      },
      (err) => {
        toastr.error("Failed", "Unable to fetch seed data");
      }
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCohortTypeChange = (event) => {
    const selectedId = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      cohortTypeId: selectedId, 
    }));
  };

 

  const handleUpdateCohort = async () => {
    if (!formData.name) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: "Cohort name is required",
      }));
      return;
    }
  
    try {
      const url = `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${id}`;
      const requestBody = { 
        ...formData,
        lat: parseFloat(formData.lat) || 0, 
        lng: parseFloat(formData.lng) || 0,  
      };
  
      props.getDataFromAPI(
        url,
        "PATCH",
        requestBody,
        (response) => {
          if (response?.status === "failure") {
            toastr.error("Error", response.message);
            return;
          }
  
          toastr.success("Success", "Cohort updated successfully");
          navigate(-1);
        },
        (err) => {
          toastr.error("API Error", err.message || "Something went wrong");
        }
      );
    } catch (err) {
      console.log("Cohort update API error:", err.message);
      toastr.error("Unexpected Error", err.message || "An error occurred");
    }
  };
  
  

  return (
    <CohortUpdateDetailsComponent
      loading={loading}
      formData={formData}
      errors={errors}
      handleInputChange={handleInputChange}
      handleCohortTypeChange={handleCohortTypeChange}
      handleUpdateCohort={handleUpdateCohort}
      selectedVM={selectedVM}
      cohortTypes={cohortTypes}
      selectedCohortType={selectedCohortType}
    />
  );
};

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  onChange_Createuser_Cohorts,
})(CohortUpdateDetailsContainer);
